import { createAction } from '@reduxjs/toolkit';

import type { UpdateGuardrailsPayload } from '@polyai/stream/commands/handlers/guardrails/update-guardrails/schema';

import { GUARDRAILS_SLICE_NAME } from './constants';

export type { UpdateGuardrailsPayload };

export const updateGuardrails = createAction<UpdateGuardrailsPayload>(
  `${GUARDRAILS_SLICE_NAME}/updateGuardrails`,
);
